import React from 'react'

function GoogleMap() {
  return (
    <div>
         <div className="album py-2">
                <div className="container">
                    <div className="row">
<iframe width="520" height="400" frameborder="0" scrolling="no" marginheight="0" marginwidth="0" id="gmap_canvas" title="Maa Manasha College of Pharmacy, Kanralia, Balidanga, Faridpur, Kaliganj, West Bengal 741153"  src="https://maps.google.com/maps?width=520&amp;height=400&amp;hl=en&amp;q=Maa%20Manasha%20College%20of%20Pharmacy%2C%20Kanralia%2C%20Balidanga%2C%20Faridpur%2C%20Kaliganj%2C%20West%20Bengal%20741153&amp;z=12&amp;ie=UTF8&amp;iwloc=B&amp;output=embed"></iframe>
                       
                    </div>
                </div>
            </div>
    </div>
  )
}

export default GoogleMap